/* 2020-09-17
 *langKey 属性名称做为多语言切换依据, langKey的属性值统一第一个大写的字母
 *文本用text做为属性名称
 * */

// 多语言切换更改数据
export const resetTextBylangKey = function (baseData, langData, keyName) {
    const list = JSON.parse(JSON.stringify(baseData))
    list.forEach((item) => {
        if (langData[item.langKey]) item[keyName || 'text'] = langData[item.langKey]
    })
    return list
}

// 底部tab数据
export const tabbarOptions = [{
    langKey: 'Home',
    text: '首页',
    src1: require("../assets/image/nav/bottom_icon_home_n.png"),
    src2: require("../assets/image/nav/bottom_icon_home_h.png"),
    icon: 'icon-shouye',
    path: '/home',
    path2: ['/', '/gamelobby/crash','/gamelobby/egame','gamelobby/lottery','/gamelobby/sports', '/gamelobby/live', '/gamelobby/chess', '/gamelobby/fish', '/gamelobby/lottery']
},
{
    langKey: 'Discounts',
    text: '优惠',
    src1: require("../assets/image/nav/bottom_icon_promotion_n.png"),
    src2: require("../assets/image/nav/bottom_icon_promotion_h.png"),
    icon: 'icon-youhui',
    path: '/promotions',
    path2: ['/promotions']
},
{
    langKey: 'Deposit',
    text: '存款',
    src1: require("../assets/image/nav/bottom_icon_deposit_n.png"),
    src2: require("../assets/image/nav/bottom_icon_deposit_h.png"),
    icon: 'icon-cunkuan',
    path: '/deposit',
    path2: ['/deposit']
},
{
    langKey: 'Withdrawal',
    text: '取款',
    src1: require("../assets/image/nav/bottom_icon_withdrawal_n.png"),
    src2: require("../assets/image/nav/bottom_icon_withdrawal_h.png"),
    icon: 'icon-withdrawal',
    // path: '/My/Withdrawal/withdrawal',
    // path2: ['/My/Withdrawal/withdrawal']
    path: '/withdraw/audit',
    path2: ['/withdraw/audit']
},
{
    langKey: 'My',
    text: '我的',
    src1: require("../assets/image/nav/bottom_icon_account_n.png"),
    src2: require("../assets/image/nav/bottom_icon_account_h.png"),
    icon: 'icon-wode',
    path: '/My',
    path2: ['/My']
}
]

// 首页游戏导航
export const gameNavOptions = [
    // {
    //   langKey: 'HotGame',
    //   gameId: "-1",
    //   path: '/game/-1',
    //   text: '热门'
    // },
    {
        langKey: 'Sport',
        gameId: "3",
        src1: require("../assets/image/gameNav/Sport.png"),
        src2: require("../assets/image/gameNav/Sport_on.png"),
        path: '/game/3',
        text: '体育',
    },
    {
        langKey: 'Live',
        gameId: "2",
        src1: require("../assets/image/gameNav/Live.png"),
        src2: require("../assets/image/gameNav/Live_on.png"),
        path: '/game/2',
        text: '真人'
    },
    {
        langKey: 'Slot',
        gameId: "1",
        src1: require("../assets/image/gameNav/Slot.png"),
        src2: require("../assets/image/gameNav/Slot_on.png"),
        path: '/game/1',
        text: '电子',
    },
    {
        langKey: 'CatchFish',
        gameId: "5",
        src1: require("../assets/image/gameNav/CatchFish.png"),
        src2: require("../assets/image/gameNav/CatchFish_on.png"),
        path: '/game/5',
        text: '捕鱼'
    },
    {
        langKey: 'Lottery',
        gameId: "4",
        src1: require("../assets/image/gameNav/Lottery.png"),
        src2: require("../assets/image/gameNav/Lottery_on.png"),
        path: '/game/4',
        text: '彩票'
    }
]


// 客服列表
export const serviceOptions = [{
    langKey: 'live_chat',
    text: 'Live Chat',
    icon: require('../assets/image/Service/livechat.png'),
    links: ''
},
{
    langKey: 'whatsapp',
    text: 'Whatsapp',
    icon: require('../assets/image/Service/whatsapp.png'),
    links: ''
},
{
    langKey: 'telegram',
    text: 'Telegram',
    icon: require('../assets/image/Service/telegram.png'),
    links: ''
},
{
    langKey: 'commonProblem',
    text: '常见问题',
    icon: require('../assets/image/Service/bulb.png'),
    links: '/Service/Problems'
}
]

// 客服常见问题(未使用)
export const serviceProblemOptions = [{
    langKey: 'aboutUs',
    text: '关于我们',
    icon: require('../assets/image/Service/livechat.png'),
    links: '/Service/Problems/Weabout'
},
{
    langKey: 'commonProblem',
    text: '常见问题',
    icon: require('../assets/image/Service/whatsapp.png'),
    links: ''
},
{
    langKey: 'connectUs',
    text: '联系我们',
    icon: require('../assets/image/Service/telegram.png'),
    links: ''
},
{
    langKey: 'serviceTerms',
    text: '服务条款',
    icon: require('../assets/image/Service/bulb.png'),
    links: ''
},
{
    langKey: 'privacyPolicy',
    text: '隐私条款',
    icon: require('../assets/image/Service/bulb.png'),
    links: ''
},
{
    langKey: 'disclaimer',
    text: '免责声明',
    icon: require('../assets/image/Service/bulb.png'),
    links: ''
},
{
    langKey: 'dutyLottery',
    text: '责任博彩',
    icon: require('../assets/image/Service/bulb.png'),
    links: ''
}
]

// 优惠详情会员信息
export const discountUserInfoOptions = [{
    text: '会员账号',
    langKey: 'userAccount',
    val: ''
},
{
    text: '当前等级',
    langKey: 'levelInfo',
    val: ''
},
{
    text: '累积投注额',
    langKey: 'totalDeposit',
    val: ''
},
{
    text: '累积晋级彩金',
    langKey: 'totalUpAmount',
    val: ''
},
{
    text: '累积周俸禄彩金',
    langKey: 'totalWeekAmount',
    val: ''
},
{
    text: '累积月俸禄彩金',
    langKey: 'totalMonthAmount',
    val: ''
},
{
    text: '晋级投注额',
    langKey: 'nextLevelDeposit',
    val: ''
}
]

// 我的 列表1
export const minBaseOptions1 = [{
    langKey: 'SaveMonery',
    text: '存款',
    imageSrc: require('../assets/image/My/l_1_1.png'),
    path: '/deposit',
    className: 'deposit'
},
{
    langKey: 'Withdrawal',
    text: '提现',
    imageSrc: require('../assets/image/My/l_1_2.png'),
    path: '/withdraw/audit',
    className: 'withdrawal'
},
    // {
    //   langKey: 'Wallet',
    //   text: '钱包',
    //   imageSrc: require('../assets/image/My/l_1_3.png'),
    //   path: '/My/Wallet'
    // },

    // {
    //   langKey: 'StationLetter',
    //   text: '站内信',
    //   imageSrc: require('../assets/image/My/l_1_3.png'),
    //   path: '/My/StationLetter'
    // }
]

// 我的 列表2 discounts
export const minBaseOptions2 = [{
    langKey: 'setting',
    text: '账户管理',
    imageSrc: require('../assets/image/My/l_2_1.png'),
    path: '/My/AccountManat',
    iconClass: 'account-icon-1'
},
{
    langKey: 'gameHistory',
    text: '游戏记录',
    imageSrc: require('../assets/image/My/l_2_6.png'),
    path: '/My/bet-record',
    iconClass: 'account-icon-5'
},
{
    langKey: 'statement',
    text: 'statement',
    imageSrc: require('../assets/image/My/l_2_5.png'),
    path: '/My/merch-record',
    iconClass: 'account-icon-4'
},
{
    langKey: 'VIP',
    text: 'VIP Club',
    imageSrc: require('../assets/image/My/account-icon-vip.png'),
    path: '/vip',
    iconClass: 'account-icon-9'
},
{
    langKey: 'Affiliate',
    text: 'Affiliate',
    imageSrc: require('../assets/image/My/account-icon-affiliate.png'),
    path: '/agency',
    iconClass: 'account-icon-10'
},
{
    langKey: 'InviteFriends',
    text: 'InviteFriends',
    imageSrc: require('../assets/image/My/l_2_8.png'),
    path: '/My/InviteFriends',
    iconClass: 'account-icon-7'
},
{
    langKey: 'wallet',
    text: '钱包',
    imageSrc: require('../assets/image/My/l_2_2.png'),
    path: '/My/Wallet',
    iconClass: 'account-icon-2'
},

// 暂时不加
// {
//   langKey: 'latestDeposit',
//   text: '存款订单记录',
//   imageSrc: require('../assets/image/My/tk.png'),
//   path: '/My/latest-deposit'
// },
// {
//   langKey: 'bankManage',
//   text: '银行卡管理',
//   imageSrc: require('../assets/image/My/l_2_3.png'),
//   path: '/My/BankManageMent'
// },
{
    langKey: 'Promotion',
    text: 'Promotion',
    imageSrc: require('../assets/image/My/l_2_8.png'),
    path: '/promo-history',
    iconClass: 'account-icon-3'
},

// {
//   langKey: 'lockAmount',
//   text: '资金锁定',
//   imageSrc: require('../assets/image/My/l_2_7.png'),
//   path: '/My/lock-amount'
// },
{
    langKey: 'StationLetter',
    text: '站内信',
    imageSrc: require('../assets/image/My/l_1_3.png'),
    // path: '/My/StationLetter',
    path: '/inbox',

    iconClass: 'account-icon-6'
},
    // {
    //   langKey: 'appDownload',
    //   text: 'APP下载',
    //   imageSrc: require('../assets/image/My/l_2_7.png'),
    //   path: '',
    //   iconClass: 'account-icon-8'
    // }
]


// 站内信 外层tab
export const StationLetterTabOptions = [{
    text: '我的消息',
    langKey: 'myMessage'
}, {
    text: '发送新消息',
    langKey: 'sendMessage'
}]

// 站内信 我的消息tab
export const myMsgTabOptions = [{
    text: '最新消息',
    val: 0,
    langKey: 'unread'
}, {
    text: '已读消息',
    val: 1,
    langKey: 'read'
}]

export const msgTypeOptions = [{
    text: '存取款问题',
    value: '0',
    langKey: 'money'
},
{
    text: '优惠活动',
    value: '1',
    langKey: 'discounts'
},
{
    text: '游戏问题',
    value: '2',
    langKey: 'games'
},
{
    text: '其它问题',
    value: '3',
    langKey: 'other'
},
{
    text: '建议',
    value: '4',
    langKey: 'proposal'
},
{
    text: '投诉',
    value: '5',
    langKey: 'complaint'
}
]

// 交易记录
export const tradingTypeOptions = [{
    text: '全部',
    langKey: 0
}, {
    text: '系统调帐',
    langKey: 1
}, {
    text: '充值存款',
    langKey: 2
},
{
    text: '秒速提款',
    langKey: 3
},
// {
//   text: '转入游戏',
//   langKey: 4
// }, {
//   text: '游戏转出',
//   langKey: 5
// },
// {
//   text: '优惠红利',
//   langKey: 8
// },
{
    text: '人工存入',
    langKey: 9
}, {
    text: '人工取出',
    langKey: 10
},
// {
//   text: '体育购买',
//   hide: true, // 表示条件不显示
//   langKey: 22
// }, {
//   text: '体育派奖',
//   hide: true,
//   langKey: 23
// }, {
//   text: '体育本金回退',
//   hide: true,
//   langKey: 24
// },
{
    text: '投注',
    langKey: 40
}, {
    text: '派彩',
    langKey: 41
}, {
    text: '佣金派发',
    langKey: 50
}, {
    text: '申请中',
    langKey: 100
},
    // {
    //   text: '充值待处理',
    //   langKey: 101
    // },{
    //   text: '提现未出款',
    //   langKey: 102
    // },
]

// 我的 -- 资金锁定明细 -- 优惠锁定
// 部分平台数据
export const platformPartOptions = [ // 平台部分数据
    {
        name: '全部平台',
        value: '',
        langKey: 'all'
    },
    {
        name: '主账户',
        value: '-1',
        langKey: 'main'
    }
]

// 红利类型
export const bonusTypeOptions = [{
    value: '',
    name: '全部类型',
    langKey: 'all'
},
{
    value: '1',
    name: '流水返利',
    langKey: 'waterRebate'
},
{
    value: '2',
    name: '存款优惠',
    langKey: 'softLoan'
},
{
    value: 'A',
    name: '救援金',
    langKey: 'rescueGold'
},
{
    value: 'B',
    name: 'VIP升级奖励',
    langKey: 'upgradeAwards'
},
{
    value: 'C',
    name: 'VIP蝉联奖励',
    langKey: 'winAwards'
},
{
    value: '5',
    name: '其他优惠',
    langKey: 'otherPreferential'
},
{
    value: '7',
    name: '注册优惠',
    langKey: 'joinPreferential'
}
]

export const dateSelectedOptions = [{
    langKey: '90',
    text: '全部'
},
{
    langKey: '1',
    text: '24小时'
},
{
    langKey: '7',
    text: '7日'
},
{
    langKey: '30',
    text: '1个月'
}
]

// 第三方登录
export const thirdPartyLoginOptions = [{
    langKey: 'Google',
    text: '谷歌'
},
{
    langKey: 'Facebook',
    text: '脸书'
},
{
    langKey: 'Twitter',
    text: '推特'
}
]

// 账户管理
export const manageOptions = [
    {
        text: '会员昵称',
        imgSrc: require('../assets/image/My/m_nickName.png'),
        value: '',
        langKey: 'playerId'
    },
    {
        text: '手机号码',
        imgSrc: require('../assets/image/My/m_app.png'),
        path: '/My/AccountManat/mobileAuth',
        value: '去认证',
        langKey: 'phone',
        langKey2: 'authe',
        Valid: 'mobileValid',
        tipsKey: 'phone'
    },
    {
        text: '真实姓名',
        imgSrc: require('../assets/image/My/m_name.png'),
        path: '/My/AccountManat/VerifiedAuth',
        value: '',
        value2: '',
        langKey: 'name',
        langKey2: 'authe',
        Valid: 'nameValid',
        tipsKey: 'name'
    },
    {
        text: '邮箱',
        imgSrc: require('../assets/image/My/m_email.png'),
        path: '/My/AccountManat/emailAuth',
        value: '去认证',
        langKey: 'email',
        langKey2: 'authe',
        Valid: 'emailValid',
        tipsKey: 'email'
    },
    {
        text: '生日',
        imgSrc: '',
        value: '',
        value2: '',
        langKey: 'birthday'
    },
    {
        text: 'whatsapp',
        imgSrc: '',
        value: '',
        value2: '',
        langKey: 'whatsappNumber'
    },
    {
        text: 'fackbook',
        imgSrc: '',
        value: '',
        value2: '',
        langKey: 'facebookAccount'
    },
    // {
    //     text: '登录密码',
    //     imgSrc: require('../assets/image/My/m_loginPwd.png'),
    //     path: '/My/AccountManat/loginPossword',
    //     value: '修改',
    //     langKey: 'loginPwd',
    //     langKey2: 'edit'
    // },
    // {
    //     text: '提款密码',
    //     imgSrc: require('../assets/image/My/m_drawPws.png'),
    //     path: '/My/AccountManat/WithdrawPasword',
    //     value: '设置',
    //     langKey: 'drawPws',
    //     langKey2: 'setting'
    // }
]



// 游戏类型
export const gameTypeOptions = [
    {
        text: '所有',
        langKey: -1
    },
    {
        text: '老虎机',
        langKey: 1
    },
    {
        text: '真人',
        langKey: 2
    },
    {
        text: '体育',
        langKey: 3
    },
    {
        text: '彩票',
        langKey: 4
    },
    {
        text: '电子捕鱼',
        langKey: 5
    },
    {
        text: '棋牌',
        langKey: 6
    },
    {
        text: '其他',
        langKey: 8
    }
]

// 代理中心tab
export const agentTabOptions = [
    {
        text: '团队盈亏',
        langKey: 'teamRevenue',
        // path: '/agent/team-revenue'
    },
    {
        text: '团队管理',
        langKey: 'teamManagement',
        // path: '/agent/team-management'
    },
    {
        text: '下级开户',
        langKey: 'subordinate',
        // path: '/agent/subordinate'
    }
]

// 首页游戏导航
export const homeTabOptions = [
    {
        langKey: 'Sport',
        gameId: "3",
        // src1: require("../assets/image/home/tab/icon-sport.png"),
        src1: require("../assets/image/home/tab/new/navi_icon_sport.png"),
        text: '体育',
        path: '/gamelobby/sports'
    },
    // 碰撞游戏
    {
        langKey: 'Crash',
        gameId: "7",
        // src1: require("../assets/image/home/tab/icon-sport.png"),
        src1: require("../assets/image/home/tab/new/navi_icon_crash.png"),
        text: '碰撞',
        path: '/gamelobby/crash'
    },
    {
        langKey: 'Live',
        gameId: "2",
        // src1: require("../assets/image/home/tab/icon-live.png"),
        src1: require("../assets/image/home/tab/new/navi_icon_chess.png"),
        text: '真人',
        path: '/gamelobby/live'
    },
    {
        langKey: 'Chess',
        gameId: "6",
        src1: require("../assets/image/home/tab/new/navi_icon_live.png"),
        text: '棋牌',
        path: '/gamelobby/chess'
    },
    {
        langKey: 'Slot',
        gameId: "1",
        src1: require("../assets/image/home/tab/new/navi_icon_slots.png"),
        text: '电子',
        path: '/gamelobby/egame'
    },
    // 彩票
    {
        langKey: 'Lottery',
        gameId: "4",
        src1: require("../assets/image/home/tab/new/navi_icon_lottery.png"),
        text: '彩票',
        path: '/gamelobby/lottery'
    },
    // 捕鱼王
    {
        langKey: 'Fish',
        gameId: "5",
        src1: require("../assets/image/home/tab/new/navi_icon_fish.png"),
        text: '捕鱼',
        path: '/gamelobby/fish'
    },
    // {
    //     langKey: 'IPL',
    //     // src1: require("../assets/image/home/tab/icon-ipl.png"),
    //     src1: require("../assets/image/home/tab/new/navi_icon_ipl3.png"),
    //     text: 'IPL',
    // },
    {
        langKey: 'Affiliate',
        src1: require("../assets/image/home/tab/new/navi_icon_affiliate.png"),
        text: 'Affiliate',
        path: '/agency'
    },
    {
        langKey: 'InviteFriends',
        src1: require("../assets/image/home/tab/new/navi_icon_friend.png"),
        text: '邀请好友',
        path: '/My/InviteFriends',
    },
    {
        langKey: 'Mobile',
        src1: require("../assets/image/home/tab/new/navi_icon_mobile.png"),
        text: '下载'
    },

]

// 时间过滤imet
export const timeFilterList = [
    {
      langKey: 'Today',
      text: 'Today',
      value: '1'
    },
    {
      langKey: 'Yesterday',
      text: 'Yesterday',
      value: '2'
    },
    {
      langKey: 'Week',
      text: 'This week',
      value: '3'
    },
    {
      langKey: 'Month',
      text: 'This Month',
      value: '4'
    },
    {
        langKey: 'LastMonth',
        text: 'Last Month',
        value: '6'
    },
]

// 团队列表
export const teamList = [
    {
      langKey: 'subFirst',
      text: 'New Friends',
      value: ''
    },
    {
      langKey: 'subFirstDeposit',
      text: 'First Deposit',
      value: ''
    },
    {
      langKey: 'subDeposit',
      text: 'Deposit Players',
      value: ''
    },
    // {
    //   langKey: 'subWithdraw',
    //   text: 'Withdraw Players',
    //   value: ''
    // },
    {
        langKey: 'subTotalDeposit',
        text: 'Deposit Amount',
        value: ''
    },
    {
        langKey: 'subTotalWithdraw',
        text: 'Withdraw Amount',
        value: ''
    },
    {
        langKey: 'subTotalBonus',
        text: 'Promote Amount',
        value: ''
    },
    {
        langKey: 'subTotalWinLoss',
        text: 'Win/Loss',
        value: ''
    },
]

// VIP
export const vipPowerList=[
    {   
        langKey: "Upgrade",
        subLangKey:'subUpgrade',
        text:'Upgrade bonus',
        icon: require('../assets/image/vip/list-icon-upgrade.png'),
        // 存款
    },
    {   
        langKey: "Birthday",
        subLangKey:'subBirthday',
        text:'Birthday bonus',
        icon: require('../assets/image/vip/list-icon-birthday.png'),
        // 取款
    },
    {   
      langKey: "Weekly",
      subLangKey:'subWeekly',
      text:'Weekly bonus',
      icon: require('../assets/image/vip/list-icon-weekly.png'),
        // 所有的优惠
    },
    {   
      langKey: "Month",
      subLangKey:'subMonth',
      text:'Month bonus',
      icon: require('../assets/image/vip/list-icon-month.png'),
        // 返水优惠
    },
    {   
      langKey: "Monthly",
      subLangKey:'subMonthly',
      text: "Monthly aid",
      icon: require('../assets/image/vip/list-icon-monthly.png'),
        // 除去反水的所有的优惠
    },
    {   
      langKey: "spin",
      subLangKey:'subSpin',
      text: "大转盘次数",
      icon: require('../assets/image/vip/list-icon-rewarding.png'),
    },
    
  ]



// WEBPACK FOOTER //
// ./src/pages/build821/libs/options.js